var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-index"},[_c('navbar',{staticClass:"mb-16"}),_c('v-main',[_c('div',{staticClass:"page-container mt-1 px-3"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }